var _path, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendarCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 25,
    viewBox: "0 0 29 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.79699 0.0546875C6.28496 0.0546875 6.68054 0.426661 6.68054 0.885514V2.56146C7.46426 2.54717 8.34273 2.54717 9.33115 2.54717H9.3312H14.0435H14.0435C15.032 2.54717 15.9104 2.54717 16.6941 2.56146V0.885514C16.6941 0.426661 17.0897 0.0546875 17.5777 0.0546875C18.0657 0.0546875 18.4612 0.426661 18.4612 0.885514V2.63497C20.1569 2.76264 21.27 3.07599 22.0879 3.845C22.9057 4.61401 23.2389 5.66074 23.3747 7.25518V8.45527H0V7.25518C0.13578 5.66074 0.46901 4.61401 1.28683 3.845C2.10464 3.07599 3.2178 2.76264 4.91343 2.63497V0.885514C4.91343 0.426661 5.30901 0.0546875 5.79699 0.0546875Z",
    fill: "#B7E7FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.3747 14.4535V12.0534C23.3747 11.0465 23.3599 9.2515 23.3448 8.45312H0.00684612C-0.00822866 9.2515 0.0065918 11.0465 0.0065918 12.0534V14.4535C0.0065918 18.9793 0.00659179 21.2422 1.37546 22.6482C2.74433 24.0542 4.9475 24.0542 9.35383 24.0542H14.0274C18.4338 24.0542 20.6369 24.0542 22.0058 22.6482C23.3747 21.2422 23.3747 18.9793 23.3747 14.4535Z",
    fill: "url(#paint0_linear_3376_6566)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5957 12.5207C16.9385 12.1608 16.9246 11.5911 16.5647 11.2483C16.2048 10.9055 15.6351 10.9194 15.2923 11.2793L9.6488 17.0672L7.79132 15.1737C7.44852 14.8138 6.87884 14.8309 6.51891 15.1737C6.15897 15.5165 6.14507 16.0551 6.48787 16.4151L8.99708 18.9928C9.16694 19.1712 9.40249 19.2722 9.6488 19.2722C9.89511 19.2722 10.1307 19.1712 10.3005 18.9928L16.5957 12.5207Z",
    fill: "#B7E7FF"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3376_6566",
    x1: 0.477915,
    y1: 8.45312,
    x2: 21.7849,
    y2: 22.184,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7DE4F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4286E5"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarCheck);
export default __webpack_public_path__ + "static/media/calendar-check.02e52d0f8ce080c917ba2f75a3abf4bd.svg";
export { ForwardRef as ReactComponent };